<template>
  <div class="hyp-container">
    <v-container fluid bg fill-height grid-list-md text-center>
      <v-row row wrap align="center">
        <v-col v-if="logoutInprocess">
          <Loader
            text="Logging out of Seerist"
            color="white"
            size="x-large"
          ></Loader>
        </v-col>
        <!--
        <v-col v-if="!logoutInprocess">
          <h2>You have been logged out, please close your browser.</h2>
          <h3>
            <v-btn @click="handleClickLogin()" color="primary" class="mt-2">
              Click here to login
            </v-btn>
          </h3>
        </v-col>
        -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { logout, isLoggedIn } from "@/common/authenticate";
import { pageTrackerLogger } from "@/common/pageTracker";
import { savePreferences } from "@/services/user/user.service";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "Logout",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  data: () => ({
    logoutInprocess: false,
  }),
  async mounted() {
    console.log("Logout on mount"); //LOGOUT DEBUGGING
    this.logoutInprocess = true;

    const loggedIn = await isLoggedIn();

    if (loggedIn) {
      await savePreferences(null, true);
      this.pageTrackerSignout();
      await logout();
    }
    this.logoutInprocess = false;
  },
  methods: {
    handleClickLogin() {
      window.location = "/";
    },
    pageTrackerSignout() {
      pageTrackerLogger("pageTrackerSignout");
      let _paq = (window._paq = window._paq || []);
      const profile = JSON.parse(localStorage.getItem("user_profile"));
      if (profile && profile.email) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.system,
          EVENT_ACTIONS.loggedOut,
          profile.email
        );
      }

      _paq.push(["resetUserId"]);
      _paq.push(["appendToTrackingUrl", "new_visit=1"]);
      _paq.push(["trackPageView"]);
      _paq.push(["appendToTrackingUrl", ""]);
    },
  },
};
</script>

<style scoped>
.bg,
.hyp-container {
  background: #191a1a;
  color: #fff;
}
</style>
